<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light" v-on:keypress.enter.prevent="getFactoryProductSaleTable(1)">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <date-picker v-model="search.date"
                                 range
                                 placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                                 :format="changeFormat"
                                 :lang="lang">
                    </date-picker> &nbsp;
                    <input v-model="search.rc_number"
                           class="form-control mr-sm-2"
                           type="search"
                           placeholder="เลข RC"
                           aria-label="Search"/>
                    <input v-model="search.employee"
                           class="form-control mr-sm-2"
                           type="search"
                           placeholder="รหัสพนักงาน"
                           aria-label="Search"/>
                    <multiselect
                        v-model="search.factory"
                        class="form-control select border-0"
                        placeholder="ค้นหาสินค้าโรงงาน"
                        :options="optionFactory"
                        :show-labels="false"
                        :customLabel="factoryLabel"
                        track-by="id">
                    </multiselect>
                    <button @click="getFactoryProductSaleTable(1)"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    <button @click="createFactoryProductSale"
                            class="btn btn-warning my-2 my-sm-0"
                            type="button">
                        <icon name="plus"></icon>
                        จำหน่าย
                    </button>
                    &nbsp
                    <button @click="printReport"
                            class="btn btn-info my-2 my-sm-0"
                            type="button">
                        <icon name="print"></icon>
                        พิมพ์ยอดขาย
                    </button>
                    &nbsp
                </form>
            </div>
        </nav>
        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">เลขที่เอกสาร</th>
                    <th scope="col">รหัสพนักงาน</th>
                    <th scope="col">ชื่อพนักงาน</th>
                    <th scope="col">วันที่จำหน่าย</th>
                    <th scope="col">ชื่อสินค้า</th>
                    <th scope="col">จำนวน</th>
                    <th scope="col">ยอดจำหน่าย</th>
                    <th scope="col">ผู้จำหน่าย</th>
                    <th scope="col">พิมพ์</th>
                    <th scope="col">แก้ไขข้อมูล</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in dataTable">
                    <td>{{ data.rc_number }}</td>
                    <td>{{ data.employee ? data.employee.employee_no : '-' }}</td>
                    <td>{{ data.employee ? data.employee.name : '-' }}</td>
                    <td>{{ data.date | moment('DD/MM/YYYY') }}</td>
                    <td>
                        <template v-if="data.details" v-for="x in data.details">
                            {{ x.factory.code + '-' + x.factory.name + '(' + x.quantity + ')' }}
                        </template>
                    </td>
                    <td>{{ data.quantity ? data.quantity : 0 | amount }}</td>
                    <td>{{ data.total ? data.total : 0 | currency }}</td>
                    <td>{{ data.user ? data.user.name : '-' }}</td>
                    <td>
                        <button type="button" class="btn btn-primary" @click="printPDFById(data.id)">
                            <icon name="print"></icon>
                            พิมพ์
                        </button>
                    </td>
                    <td>
                        <a @click="showFactoryProductSaleForm(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>&nbsp;&nbsp;
                        <a @click="deleteProductSale(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <vue-pagination :pagination="dataPaginate"
                        @paginate="getFactoryProductSaleTable(dataPaginate.current_page)">
        </vue-pagination>
        <b-modal
            ref="delete_item"
            hide-header
            hide-footer>
            <div style="text-align: center;">
                <h4>คุณต้องการลบใช่หรือไม่</h4>
                <br/>
                <button type="button"
                        class="btn btn-success"
                        @click="DeleteConfirm()">ตกลง
                </button>
                &nbsp&nbsp
                <button type="button"
                        class="btn btn-secondary"
                        @click="hideModalDelete()">ยกเลิก
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import Multiselect from "vue-multiselect";
import VuePagination from "../Pagination";
import {domain} from "../../util/Constants";

export default {
    name: "FactoryProductSaleTable",
    components: {
        VuePagination,
        DatePicker,
        Multiselect,
    },
    created() {
        this.getFactoryProductSaleTable(1);
        this.getFactoryEmployeeAll();
    },
    data() {
        return {
            optionFactory: [],
            search: {
                factory: '',
                employee: '',
                date: [],
                start_date: '',
                end_date: '',
                rc_number: ''
            },
            delete_id: '',
            dataTable: [],
            dataPaginate: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    methods: {
        factoryLabel(option) {
            return `${option.code} - ${option.name}`
        },
        getFactoryEmployeeAll() {
            this.$store.dispatch('FactoryEmployee/getFactoryEmployeeAll').then(res => {
                this.optionFactory = res;
            })
        },
        getFactoryProductSaleTable(page) {
            let start_date = '';
            let end_date = '';
            if (this.search.date.length && this.search.date[0]) {
                start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
            }
            let data = {
                factory_id: this.search.factory ? this.search.factory.id : '',
                start_date,
                end_date,
                rc_number: this.search.rc_number,
                employee: this.search.employee,
            };
            this.$store.dispatch("FactoryEmployeeSale/getFactoryEmployeeSale", {
                page,
                data,
            }).then(res => {
                this.dataTable = res.data;
                this.dataPaginate = {
                    current_page: res.current_page,
                    from: res.from,
                    last_page: res.last_page,
                    per_page: res.per_page,
                    total: res.total,
                    to: res.to
                }
            })
        },
        showFactoryProductSaleForm(id) {
            this.$store.dispatch("FactoryEmployeeSale/showFactoryEmployeeSale", id).then(res => {
                if (res) {
                    this.$store.dispatch("FactoryEmployeeSale/setFormData", res).then(() => {
                        this.goToFormPage();
                    })
                } else {
                    alert("ไม่สามารถแสดงข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
                }
            }).catch(() => {
                alert("ไม่สามารถแสดงข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
            })
        },
        deleteProductSale(id) {
            this.showModalDelete(id);
        },
        createFactoryProductSale() {
            this.$store.dispatch("FactoryEmployeeSale/clearFormData").then(() => {
                this.goToFormPage();
            })
        },
        printReport() {
            let start_date = '';
            let end_date = '';
            if (this.search.date.length && this.search.date[0]) {
                start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
            }
            let data = {
                factory_id: this.search.factory ? this.search.factory.id : '',
                start_date,
                end_date,
                rc_number: this.search.rc_number,
                employee: this.search.employee,
            };
            window.open(`${domain}/factory_sale_excel?factory_id=${data.factory_id}&start_date=${data.start_date}
                &end_date=${data.end_date}&rc_number=${data.rc_number}&employee=${data.employee}`, '_blank')
        },
        goToFormPage() {
            this.$router.push('/factory-sale-form');
        },
        printPDFById(id) {
            window.open(`${domain}/factory_sale_pdf/${id}`, '_blank')
        },
        DeleteConfirm() {
            this.$store.dispatch("FactoryEmployeeSale/deleteFactoryEmployeeSale", this.delete_id).then(() => {
                this.hideModalDelete()
                this.getFactoryProductSaleTable(1)
            })
        },
        hideModalDelete() {
            this.$refs.delete_item.hide();
        },
        showModalDelete(id) {
            this.delete_id = id;
            this.$refs.delete_item.show();
        },
    }
}
</script>

<style scoped>
</style>
